import React from 'react';
export const RoundedSquare = ({ borderColor }) => (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "#FFFFFF", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("rect", { x: "0.5", y: "0.5", width: "23", height: "23", rx: "7.5", stroke: borderColor })));
//# sourceMappingURL=RoundedSquare.js.map